import { t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
import { Button } from '@repo/ui/button';
import { UserCog, X } from 'lucide-react';
import { Activity } from 'react';

interface OfficersTableEmptyStateProps {
  searchQuery: string;
  onClearFilters: () => void;
  hasFilters: boolean;
}

export function OfficersTableEmptyState({
  searchQuery,
  onClearFilters,
  hasFilters,
}: OfficersTableEmptyStateProps) {
  useLocale();

  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <UserCog className="mb-4 h-12 w-12 text-muted-foreground" />
      <h3 className="mb-2 font-semibold text-lg">{t('workspace.noOfficersFound')}</h3>
      <p className="text-muted-foreground">
        {searchQuery
          ? t('workspace.noOfficersMatchYourSearchCriteria')
          : t('workspace.thereAreNoOfficersInYourOrganizationYet')}
      </p>
      <Activity mode={hasFilters ? 'visible' : 'hidden'}>
        <Button className="mt-4 bg-background" onClick={onClearFilters} variant="outline">
          <X className="h-4 w-4" />
          {t('workspace.clearFilters')}{' '}
        </Button>
      </Activity>
    </div>
  );
}
